import store from '../store'

export default function (to, from, next) {
    if (from === to) {
        store.dispatch('charge/reset')
        store.dispatch('packs/reset')
        store.dispatch('providers/reset')
    }

    return next()
}
